var toCamelCase;

toCamelCase = function(s) {
  var Word;
  if (!s) {
    throw new Error('String not defined');
  }
  Word = function(w) {
    return w.charAt().toUpperCase() + w.slice(1);
  };
  return s.split(/[-\s_.,&]+/g).map(Word).join('');
};

module.exports = {
  toCamelCase: toCamelCase
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9zcmMvaGVscGVycy9jYW1lbENhc2UuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9zcmMvaGVscGVycy9jYW1lbENhc2UuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsV0FBQSxHQUFjLFNBQUMsQ0FBRDtBQUNaLE1BQUE7RUFBQSxJQUF3QyxDQUFJLENBQTVDO0FBQUEsVUFBVSxJQUFBLEtBQUEsQ0FBTSxvQkFBTixFQUFWOztFQUNBLElBQUEsR0FBTyxTQUFDLENBQUQ7V0FBTyxDQUFDLENBQUMsTUFBRixDQUFBLENBQVUsQ0FBQyxXQUFYLENBQUEsQ0FBQSxHQUEyQixDQUFDLENBQUMsS0FBRixDQUFRLENBQVI7RUFBbEM7U0FDUCxDQUFDLENBQUMsS0FBRixDQUFRLGFBQVIsQ0FBc0IsQ0FBQyxHQUF2QixDQUEyQixJQUEzQixDQUFnQyxDQUFDLElBQWpDLENBQXNDLEVBQXRDO0FBSFk7O0FBS2QsTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDZixhQUFBLFdBRGUifQ==
